"use client"

import { NftsToBuyMoleculeReatom } from "@/app/nft/buy/nfts-to-buy/molecule.reatom"
import { NftsSelectionScope } from "@/app/nft/nfts-selection/nfts-selection-scope"
import { reatomComponent } from "@reatom/react"
import { ScopeProvider, useMolecule } from "bunshi/react"
import { useMemo } from "react"

interface Props {
  children: React.ReactNode
}

export const NftsSelectionScopeProvider = reatomComponent<Props>(
  ({ children }) => {
    const { selectedNftsToBuy, toggleNftSelection } = useMolecule(
      NftsToBuyMoleculeReatom,
    )

    // Pass Reatom atoms and actions directly to scope
    const value = useMemo(
      () => ({
        selectedNftsAtom: selectedNftsToBuy,
        toggleNftSelectionAction: toggleNftSelection,
        selectionAvailable: true,
      }),
      [selectedNftsToBuy, toggleNftSelection],
    )

    return (
      <ScopeProvider scope={NftsSelectionScope} value={value}>
        {children}
      </ScopeProvider>
    )
  },
  "NftsSelectionScopeProvider",
)
